<template>
  <div class="bigScreen flex f-d">
    <img class="img" src="../assets/bigScreen_images/Group 1890.png" alt="" />
    <div class="frame_top">
      <img src="../assets/bigScreen_images/Frame 1903.png" alt="" />
      <p class="flex">
        <img src="../assets/bigScreen_images/icon／通用／time .png" alt="" />
        <span>{{ locaTime }}</span>
      </p>
      <div class="frame_title">
        <img src="../assets/bigScreen_images/title.png" alt="" />
      </div>
    </div>
    <div class="flex j-c container">
      <div class="both-sides flex f-d j-c">
<!--        <div class="both-t flex f-d j-c">-->
<!--          <div class="title">-->
<!--            <img src="../assets/bigScreen_images/Frame 1888.png" alt="" />-->
<!--            <p>受教育程度</p>-->
<!--          </div>-->
<!--          <div class="content">-->
<!--            <education-level :options="EduLevel" />-->
<!--          </div>-->
<!--        </div>-->
        <div class="both-m">
          <div class="title">
            <img src="../assets/bigScreen_images/Frame 1888.png" alt="" />
            <p>考核通过率</p>
          </div>
          <div class="content">
            <ul class="course">
              <li v-for="(item, index) in coursePass" :key="index">
                <span>{{ item.courseName }}</span>
                <course-pass :chartData="item.passRate" :index="index" />
              </li>
            </ul>
          </div>
        </div>
        <div class="both-l">
          <div class="title">
            <img src="../assets/bigScreen_images/Frame 1887.png" alt="" />
            <p>男女构成</p>
          </div>
          <div class="content" style="height: calc(100% - 44px)">
            <worker-sex :options="WorkerSex" />
          </div>
        </div>
      </div>
      <div class="chart-m flex f-d">
        <div class="both-t">
          <ul class="flex j-c custom">
            <li v-for="(item, index) in customData" :key="index">
              <div class="topLeft"></div>
              <div class="topRight"></div>
              <div class="bottomLeft"></div>
              <div class="bottomRight"></div>
              <p class="d-num">{{ item.dataNumber }}</p>
              <p class="d-title">{{ item.dataTitle }}</p>
            </li>
          </ul>
        </div>
        <div class="both-m"></div>
<!--        <div class="both-c">-->
<!--          <div class="title" style="width: 65%">-->
<!--            <img src="../assets/bigScreen_images/Frame 1888.png" alt="" />-->
<!--            <p>证书领取情况</p>-->
<!--          </div>-->
<!--          <div class="content" style="height: 160px">-->
<!--            <certificate :options="Certificate" />-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="both-sides flex f-d j-c">
        <div class="both-t flex f-d j-c">
          <div class="title">
            <img src="../assets/bigScreen_images/Frame 1886.png" alt="" />
            <p>合格率</p>
          </div>
          <div class="content">
            <ul class="flex j-c attend">
              <li v-for="(item, index) in attendence" :key="index">
                <attendance :chartData="item.attendence" :index="index" />
                <span>{{ item.courseName | subStr }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="both-m">
          <div class="title">
            <img src="../assets/bigScreen_images/Frame 1889.png" />
            <p>课程上课次数</p>
          </div>
          <div class="content" style="height: calc(100% - 44px)">
            <most-learn :options="MostLearn" />
          </div>
        </div>
        <div class="both-l">
          <div class="title">
            <img src="../assets/bigScreen_images/Frame 1888.png" alt="" />
            <p>职工年龄段</p>
          </div>
          <div class="content" style="height: calc(100% - 44px)">
            <emp-age :options="EmpAge" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EducationLevel from "@/components/Charts/EducationLevel.vue";
import TimeUtil from "@/utils/TimeUtil";
import HttpConnectionC from "@/utils/HttpConnectionC";
import CoursePass from "../components/Charts/CoursePass.vue";
import Attendance from "../components/Charts/Attendance.vue";
import Certificate from "../components/Charts/Certificate.vue";
import EmpAge from "../components/Charts/EmpAge.vue";
import MostLearn from "../components/Charts/MostLearn.vue";
import WorkerSex from "../components/Charts/WorkerSex.vue";

export default {
  components: {
    EducationLevel,
    CoursePass,
    Attendance,
    Certificate,
    EmpAge,
    MostLearn,
    WorkerSex,
  },
  name: 'BigScreen',
  data () {
    return {
      // 教育程度
      EduLevel: {
        indicator: [],
        value: null,
      },
      coursePass: null,
      attendence: null,
      Certificate: {
        xAxis: null,
        legList: null,
        seriesData: null,
      },
      MostLearn: {
        courseName: null,
        count: null,
      },
      EmpAge: {
        ageGroup: null,
        totalNumber: null,
      },
      WorkerSex: {
        pieData: [],
      },
      customData: [],
    };
  },
  computed: {
    locaTime () {
      let { Y, M, D } = TimeUtil.getLocalTime(new Date());
      return `${Y}-${M}-${D}`;
    },
  },
  filters: {
    subStr (value) {
      return value.slice(0, 8) + (value.length > 8 ? "..." : "");
    },
  },
  created () {
    this.getEduLevel();
    this.getCoursePass();
    this.getAttendence();
    this.getCertificate();
    this.getMostLearn();
    this.getEmpAge();
    this.getWorkerSex();
    this.getCustomData();
  },
  methods: {

    // 受教育程度
    getEduLevel () {
      HttpConnectionC.get("/datastatistics/listWorkerQualifications").then(
        ({ data }) => {
          data.forEach((item) => {
            this.EduLevel.indicator.push({
              name: item.educatedLevel,
              max: item.workerTotalNumber,
            });
          });
          this.EduLevel.value = data.map((item) => item.workerNumber);
        }
      );
    },
    // 考核通过率
    getCoursePass () {
        let data = [
            {
                "courseName": "红十字课程",
                "passNumber": 4235,
                "passRate": 1
            }
        ]
        this.coursePass = data;
      // HttpConnectionC.get("/datastatistics/listCoursePassRate").then(
      //   ({ data }) => {
      //     this.coursePass = data;
      //   }
      // );
    },
    // 出勤率
    getAttendence () {
        let data = [
            {"courseName": "红十字课程", "attendence" : 1},
            // {"courseName": "铁路调车作业", "attendence" : 1}
        ];
        this.attendence = data;
        // HttpConnectionC.get("/datastatistics/listAttendence").then(({ data }) => {
      //   this.attendence = data;
      // });
    },
    // 证书领取情况
    getCertificate () {
      HttpConnectionC.get("/datastatistics/listCertificate").then(
        ({ data }) => {
          this.Certificate.xAxis = data[0].detailDataList.map(
            (item) => item.month
          );
          this.Certificate.legList = data.map((item) => item.certificateName);
          this.Certificate.seriesData = data;
        }
      );
    },
    // 上课次数
    getMostLearn () {
        let data = [
            {
                "courseName": "红十字课程",
                "clickCount": "82576"
            },
            // {
            //     "courseName": "铁路调车作业",
            //     "clickCount": "69854"
            // }
        ];
        this.MostLearn.courseName = data.map((item) => item.courseName);
        this.MostLearn.count = data.map((item) => item.clickCount);
      // HttpConnectionC.get("/datastatistics/listMostLearn").then(({ data }) => {
      //   this.MostLearn.courseName = data.map((item) => item.courseName);
      //   this.MostLearn.count = data.map((item) => item.clickCount);
      // });
    },
    // 员工年龄段
    getEmpAge () {
        let data = [
            {
                "ageGroup": "20岁以下",
                "maleNumber": 49,
                "maleNumberRate": 0.0032,
                "femaleNumber": 20,
                "femaleNumberRate": 0.0013,
                "unknownNumber": 0,
                "unknownNumberRate": 0.0,
                "totalNumber": 369
            },
            {
                "ageGroup": "20岁至30岁",
                "maleNumber": 1013,
                "maleNumberRate": 9.0E-4,
                "femaleNumber": 981,
                "femaleNumberRate": 1.0E-4,
                "unknownNumber": 0,
                "unknownNumberRate": 0.0,
                "totalNumber": 2147
            },
            {
                "ageGroup": "30岁至40岁",
                "maleNumber": 892,
                "maleNumberRate": 1.0E-4,
                "femaleNumber": 1930,
                "femaleNumberRate": 0.0,
                "unknownNumber": 0,
                "unknownNumberRate": 0.0,
                "totalNumber": 1930
            },
            {
                "ageGroup": "未知年龄",
                "maleNumber": 645,
                "maleNumberRate": 0.3076,
                "femaleNumber": 1997,
                "femaleNumberRate": 0.1322,
                "unknownNumber": 8377,
                "unknownNumberRate": 0.5547,
                "totalNumber": 1997
            }
        ];
        this.EmpAge.ageGroup = data.map((item) => item.ageGroup);
        this.EmpAge.totalNumber = data.map((item) => item.totalNumber);
      // HttpConnectionC.get("/datastatistics/listWorkerAgeGroup").then(
      //   ({ data }) => {
      //     this.EmpAge.ageGroup = data.map((item) => item.ageGroup);
      //     this.EmpAge.totalNumber = data.map((item) => item.totalNumber);
      //   }
      // );
    },
    // 男女构成比例
    getWorkerSex () {
      HttpConnectionC.get("/datastatistics/listWorkerSex").then(({ data }) => {
        data.forEach((item) => {
          this.WorkerSex.pieData.push({
            value: item.number,
            name: item.sex + "\n" + parseInt(item.numberRate * 100) + "%",
          });
        });
      });
    },
    getCustomData () {
      HttpConnectionC.get("/datastatistics/customdata/list?showFlag=2").then(
        ({ rows }) => {
          console.log(rows);
          this.customData = rows.slice(0, 4);
        }
      );
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.flex {
  display: flex;
}
.f-d {
  flex-direction: column;
}
.j-c {
  justify-content: space-between;
}
div {
  color: #fff;
}
img {
  width: 100%;
  height: 100%;
}
.title {
  position: relative;
  height: 44px;
  img {
    width: 100%;
    height: 100%;
  }
  p {
    position: absolute;
    top: 5px;
    left: 16px;
    font-size: 22px;
  }
}
.both-t {
  width: 100%;
  height: 25%;
}
.both-m {
  flex: 1;
}
.both-l {
  width: 100%;
  height: 33%;
}
.content {
  flex: 1;
  .attend {
    ul {
      width: 100%;
    }
    li {
      width: 33%;
      height: 150px;
      position: relative;
      text-align: center;
    }
    span {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 5px;
      font-size: 14px;
    }
  }
}

.bigScreen {
  height: 100vh;
  background: #151a30 url("../assets/bigScreen_images/Group 1879.png") no-repeat;
  position: relative;
  .img {
    position: absolute;
    width: 55%;
    height: 55%;
    top: 18%;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .frame_top {
    width: 100%;
    height: 15%;
    position: relative;
    p {
      position: absolute;
      top: 10px;
      left: 16px;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      span {
        margin-left: 10px;
      }
    }
    .frame_title {
      position: absolute;
      width: 26%;
      top: 15px;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .container {
    flex: 1;
    padding: 0 20px;
    .both-sides {
      width: 24%;
    }
    .course {
      li {
        position: relative;
        padding-top: 16px;
        span {
          position: absolute;
          font-size: 14px;
          left: 6px;
          top: 10px;
        }
      }
    }
    .chart-m {
      width: 42%;
      .both-c {
        height: 28%;
      }
      li {
        width: 23%;
        text-align: center;
        background: radial-gradient(
          rgba(15, 51, 79, 0) 0%,
          rgba(21, 85, 136, 0.2) 100%
        );
        padding: 10px;
        margin-top: 20px;
      }
    }

    .custom {
      li {
        position: relative;
        div {
          position: absolute;
          width: calc(100% + 2px);
          height: calc(100% + 2px);
        }
        div.topLeft {
          top: -1px;
          left: -1px;
          width: 10px;
          height: 10px;
          z-index: 3;
          border: 1px solid #5fd5ec;
          border-right: none;
          border-bottom: none;
        }
        div.topRight {
          top: -1px;
          right: -1px;
          width: 10px;
          height: 10px;
          z-index: 3;
          border: 1px solid #5fd5ec;
          border-left: none;
          border-bottom: none;
        }
        div.bottomLeft {
          bottom: -1px;
          left: -1px;
          width: 10px;
          height: 10px;
          z-index: 3;
          border: 1px solid #5fd5ec;
          border-right: none;
          border-top: none;
        }
        div.bottomRight {
          bottom: -1px;
          right: -1px;
          width: 10px;
          height: 10px;
          z-index: 3;
          border: 1px solid #5fd5ec;
          border-left: none;
          border-top: none;
        }
      }
      p.d-num {
        color: #5fd5ec;
        font-weight: bold;
        font-size: 26px;
      }
      p.d-title {
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
</style>

